import { useCallback } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
export const useStoreTrackingEvent = () => {
    const messageBus = useMessageBus();
    const publish = useCallback((storeId, storeName, storetype) => {
        messageBus.publish("tracking.event", {
            payload: {
                event_name: "store_locator_search_results_click",
                additionalData: {
                    store_id: storeId,
                    store_name: storeName,
                    store_type: storetype,
                },
            },
        });
    }, [messageBus]);
    return publish;
};
//# sourceMappingURL=useStoreTrackingEvent.js.map